// src/themes/macarons.ts
// Paleta clásica Macarons de ECharts + ajustes suaves.
// Puedes ampliar el objeto si quieres modificar fuentes, ejes, etc.
export const MacaronsTheme = {
    color: [
        '#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80',
        '#8d98b3', '#e5cf0d', '#97b552', '#95706d', '#dc69aa'
    ],
    backgroundColor: 'transparent',
    textStyle: {
        fontFamily: 'inherit'
    },
    title: {
        textStyle: { fontWeight: 600 }
    },
    tooltip: {
        axisPointer: { lineStyle: { type: 'dashed' } }
    },
    legend: {
        itemWidth: 12,
        itemHeight: 8
    },
    // Estilos por tipo (puedes ampliar según lo que uses)
    pie: {
        itemStyle: { borderColor: '#fff', borderWidth: 1 }
    },
    line: {
        smooth: true
    },
    bar: {
        itemStyle: { borderRadius: [4, 4, 0, 0] }
    }
};
